import React from 'react';
import AuthAdminUserModel from '../code/models/AuthAdminUserModel';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/mainheader.css';
import ApiAuth from '../code/api/ApiAuth';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import Api_Config from '../code/api/ApiConfig';
import AdminMenu from "./admin/AdminMenu";

// @ts-ignore ignore this line, compiler issue, works ok in runtime
import userIcon from '../images/user-icon.svg';
const logo = require('../images/ccl-logo.png');
const logoIcon = require('../images/ccl-icon.png');

interface IMainHeader {
  currentUser: AuthAdminUserModel | null | undefined,
  onLogoff: Function,
  onCompanyChanged: Function,
  onSelectPage(page: string): void,
  onSelectSubPage(subPage: string): void,
  currentPage: string
}

export default function MainHeader({ currentUser, onLogoff, onCompanyChanged, onSelectPage,
  onSelectSubPage, currentPage }: IMainHeader) {
  var selectedSystem = Api_Config.getSelectedCompany();
  const [companyDropdownOpen, setCompanyDropdownOpen] = React.useState(false);
  const companyToggle = () => setCompanyDropdownOpen((prevState) => !prevState);
  const [adminDropdownOpen, setAdminDropdownOpen] = React.useState(false);
  const adminToggle = () => setAdminDropdownOpen((prevState) => !prevState);

  function handleLogoffClick() {
    onLogoff();
  }

  function handleCompanyCodeClick(companyCode: string) {
    if (currentUser?.cid?.toUpperCase() !== companyCode?.toUpperCase()) {
      // api call change company
      ApiAuth.ChangeCompanyCode(companyCode).then(result => {
        if (result) {
          // success, trigger that the company has changed
          onCompanyChanged();
          handleAdminPageClick("main");
          try {
            // remember last company used
            localStorage.setItem(ApiAuth.lasCompanyLocalStorageKey, companyCode);
          } catch { }
        }
      });
    }
  }

  function buildCompanyListItem(companyCode: string) {
    return (
      <DropdownItem href="#" onClick={() => { handleCompanyCodeClick(companyCode); }}
        key={"companydropdown_" + companyCode}>{companyCode?.toUpperCase()}</DropdownItem>
    )
  }

  function buildCompanyDropDown() {
    return (
      <React.Fragment>
        <Dropdown key="companyDropDown" isOpen={companyDropdownOpen} toggle={companyToggle}
          className="user-main-button">
          <DropdownToggle caret size="lg" color="" >
            {currentUser?.cid?.toUpperCase()}
          </DropdownToggle>
          <DropdownMenu>
            {currentUser?.companies.map((rowData: any, index: number) => { return buildCompanyListItem(rowData); })}
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    )
  }

  function buildCompanyButtons() {
    var companyCount = currentUser?.companies?.length || 0;
    return (
      <React.Fragment>
        {companyCount > 0 && buildCompanyDropDown()}
      </React.Fragment>
    )
  }

  function handleAdminPageClick(page: string) {
    onSelectPage(page);
  }

  function buildAdminLinks() {
    if (!Api_Config.isLegacy() && currentPage !== "admin" && !!currentUser && currentUser.canShowAdminScreen) {
      return (
        <React.Fragment>
          <DropdownItem href="#" onClick={() => { handleAdminPageClick("admin"); }}>Admin Pages</DropdownItem>
          <DropdownItem divider></DropdownItem>
        </React.Fragment>
      )
    } else return null;
  }

  function buildCustomerPagesLinks() {
    if (currentPage !== "main") {
      return (
        <React.Fragment>
          <DropdownItem href="#" onClick={() => { handleAdminPageClick("main"); }} >Customer Pages</DropdownItem>
          <DropdownItem divider></DropdownItem>
        </React.Fragment>
      )
    } else return null;
  }

  function buildAdminUserLinks() {
    if (currentPage !== "my-profile") {
      return (
        <React.Fragment>
          <DropdownItem href="#" onClick={() => { handleAdminPageClick("my-profile"); }}>My Profile</DropdownItem>
          <DropdownItem divider></DropdownItem>
        </React.Fragment>
      )
    } else return null;
  }

  function buildUserButton() {
    return (
      <Dropdown key="userdropdown" isOpen={adminDropdownOpen} toggle={adminToggle}
        className="user-main-button">
        <DropdownToggle caret size="lg" color="">
          <img src={userIcon} alt="User" className="user-icon" />
        </DropdownToggle>
        <DropdownMenu>
          {buildAdminLinks()}
          {buildCustomerPagesLinks()}
          {buildAdminUserLinks()}
          <DropdownItem href="#" onClick={handleLogoffClick}>Log Off</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    )
  }

  function buildAdminButtons() {
    if (!currentUser || currentPage !== "admin") {
      return (
        <div className="user-admin-buttons"></div>
      )
    }
    return (
      <React.Fragment>
        <AdminMenu adminUser={currentUser} adminPageClickCallback={onSelectSubPage} />
      </React.Fragment>
    )
  }

  return (
    <header className='main-header'>
      <img src={logo} alt="CCL Software" className="main-logo" />
      <img src={logoIcon} alt="CCL Software" className="main-logo-icon" />
      {buildAdminButtons()}
      {!!currentUser && <div className="header-company-id">{selectedSystem.displayName}</div>}
      {!!currentUser && buildCompanyButtons()}
      {!!currentUser && buildUserButton()}
    </header>
  )
}
